export default __webpack_public_path__ + "static/media/favicon.fc3ff21e.ico";